import * as React from 'react';
import { TimezoneSelectionDataHooks } from './TimezoneSelectionDataHooks';
import { classes, st } from './TimezoneSelection.st.css';
import { FloatingDropdown } from 'wix-ui-tpa/FloatingDropdown';
import { Text } from 'wix-ui-tpa/Text';
import { formatTimezone } from '@wix/bookings-uou-mappers';
export var TimezoneSelection = function (_a) {
    var selectedTimezone = _a.selectedTimezone, isMobile = _a.isMobile, timezoneOptions = _a.timezoneOptions, onTimezoneSelected = _a.onTimezoneSelected, locale = _a.locale, _b = _a.dateToPick, dateToPick = _b === void 0 ? new Date() : _b, _c = _a.timezoneLabel, timezoneLabel = _c === void 0 ? '' : _c, className = _a.className;
    var onChange = function (selectedOption) {
        selectedOption.id && onTimezoneSelected(selectedOption.id);
    };
    var formattedTimezone = formatTimezone({
        date: dateToPick,
        locale: locale,
        timezone: selectedTimezone,
    });
    var shouldShowTimezoneDropdown = timezoneOptions.length > 1;
    return (React.createElement("div", { "data-hook": TimezoneSelectionDataHooks.TIMEZONE_SELECTION, className: st(classes.root, {}, className) }, shouldShowTimezoneDropdown ? (React.createElement(FloatingDropdown, { className: st(classes.timezoneDropdown, { isMobile: isMobile }), "data-hook": TimezoneSelectionDataHooks.TIMEZONE_DROPDOWN, onChange: onChange, options: timezoneOptions.map(function (timezone, index) { return ({
            id: timezone,
            value: formatTimezone({
                date: dateToPick,
                locale: locale,
                timezone: timezone,
            }),
            isSelectable: true,
        }); }), label: timezoneLabel, value: selectedTimezone, displayBlock: isMobile })) : (React.createElement(Text, { "data-hook": TimezoneSelectionDataHooks.TIMEZONE_TEXT, className: st(classes.timezoneText) }, formattedTimezone))));
};
//# sourceMappingURL=TimezoneSelection.js.map